<template>
  <div style="padding-right:95px; padding-left:95px">
    <div>
      <!-- <input type="button" class="btn btn-sm btn-success pull-right" value="Print Receipt" v-on:click="PrintSection"> -->
       <CButton
          type="submit"
          color="success"
          class="btn btn-sm btn-success pull-right"
          @click="PrintPage"
        >Print Receipt</CButton>
    </div>
    <br><br>
    <div id="printsection">
    <div style="background-color: black; color: white; width: 100%; padding: 5px; text-align: center; font-weight: bold;">
      R  E  C  E  I  P  T
    </div>
    <br>

    <CRow style="display: inline-flex;">
      <div class="col col-lg-2">
        <img v-if="receipt.ProfilePicture == null" src="../assets/img/default.png" style="width:120px;height:120px">
         <img v-else :src="getPic(receipt)" style="width:120px;height:120px"/>
        <div>{{ receipt.TuitionCenterName }}</div>
      </div>
      <div class="col ml-2">
        <div style="font-size: 15px; font-weight: 300;">{{ receipt.TuitionCenterDescription }}</div>
        <div style="font-size: 15px; font-weight: 300;">Phone: {{ receipt.TuitionCenterPhone }}</div>
      </div>
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered">
            <tr>
              <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Month</td>
              <td class="text-right" style="padding:5px; border: 1px solid black;">{{ receipt.Note }}</td>
            </tr>
              <tr>
              <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Student Name</td>
              <td class="text-right" style="padding:5px; border: 1px solid black;">{{ receipt.StudentName }}</td>
            </tr>
            <tr>
              <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Tuition Invoice Id</td>
              <td class="text-right" style="padding:5px; border: 1px solid black;">{{ receipt.InvoiceId }}</td>
            </tr>
            <tr>
              <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Date</td>
              <td  class="text-right" style="padding:5px; border: 1px solid black;">{{ receipt.Date | moment("DD MMM YYYY")}}</td>
            </tr>
            <tr>
              <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Amount Due (MYR)</td>
              <td class="text-right" style="padding:5px; border: 1px solid black;">RM {{ receipt.Amount }}</td>
            </tr>
          </table>
        </div>
      </div>
    </CRow>

    <CRow>
      <CCol md="12">
        <div>
          <table style="width: 100%; border-bottom: 1px solid #000; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000; ">
            <tr>
              <th style="width: 25%; background-color:#2f9e9e; color:#fff; padding: 5px; border-bottom: 1px solid #000; border-right: 1px solid #000;">Item</th>
              <th style="width: 30%; background-color:#2f9e9e; color:#fff; padding: 5px; border-bottom: 1px solid #000; border-right: 1px solid #000;">Description</th>
              <th style="width: 15%; background-color:#2f9e9e; color:#fff; padding: 5px; border-bottom: 1px solid #000; border-right: 1px solid #000;">Unit Cost</th>
              <th style="width: 15%; background-color:#2f9e9e; color:#fff; padding: 5px; border-bottom: 1px solid #000; border-right: 1px solid #000;">Quantity</th>
              <th style="width: 15%; background-color:#2f9e9e; color:#fff; padding: 5px; border-bottom: 1px solid #000;">Price</th>
            </tr>
            <tr v-for="item in receipt.Package" v-bind:key="item.Id">
              <td style="padding: 5px;">{{ item.PackageName}}</td>
              <td style="padding: 5px;">{{ item.PackageDescription}}</td>
              <td style="padding: 5px;">RM {{ item.PackageFee }}</td>
              <td style="padding: 5px;">1</td>
              <td style="padding: 5px;">RM {{ item.PackageFee }}</td>
            </tr>
            <br>
            <tr v-for="item in receipt.Additional" v-bind:key="item.Id">
              <td style="padding: 5px;">Additional Payment</td>
              <td style="padding: 5px;"><li>{{ item.PaymentInfo }}</li></td>
              <td style="padding: 5px;">RM {{ item.PaymentFee }}</td>
              <td style="padding: 5px;">1</td>
              <td style="padding: 5px;">RM {{ item.PaymentFee }}</td>
            </tr>
            <br>
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right" style="border-left: 1px solid #000; padding:10px; border-top: 1px solid #000;">Discount</td>
              <td style="padding:10px; border-top: 1px solid #000;">RM {{ receipt.Discount }}</td>
            </tr>
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right" style="border-left: 1px solid #000; padding:10px; border-top: 1px solid #000;">Final Amount</td>
              <td style="padding:10px; border-top: 1px solid #000;">RM {{ receipt.PaymentFee - receipt.Discount + receipt.TotalAdditional }}</td>
            </tr>
            <tr>
              <td colspan="2"></td>
              <td colspan="2" class="text-right" style="border-left: 1px solid #000; padding:10px; border-top: 1px solid #000;">Amount Paid</td>
              <td style="padding:10px; border-top: 1px solid #000;">RM {{ receipt.PaymentAmount }}</td>
            </tr>
            <tr>
              <td colspan="2"></td>
              <td v-if="receipt.Balance >= 0" colspan="2" class="text-right" style="border-left: 1px solid #000; padding:10px; border-top: 1px solid #000; background-color:#ededed;">Balance Exceed</td>
              <td v-else colspan="2" class="text-right" style="border-left: 1px solid #000; padding:10px; border-top: 1px solid #000; background-color:#ededed;">Balance Remaining</td>
             
             <td style="padding:10px; border-top: 1px solid #000; background-color:#ededed;">RM {{ receipt.PaymentAmount - (receipt.PaymentFee - receipt.Discount + receipt.TotalAdditional)}}</td>
            </tr>
          </table>
        </div>
      </CCol>
    </CRow>
    
    <br>
    <div>
      <strong>** Balance Exceed = </strong>the remaining balance is when the payer has overpaid to the tuition center <br>
      <strong>** Balance Remaining = </strong>the remaining balance is when the payer has remaining balance that need to be paid to the tuition center
    </div>
    <br>
  </div>
  </div>
</template>



<style>
table-head {
  width: 25%; 
  background-color:#2f9e9e; 
  color:#fff; 
  padding: 5px; 
  border-bottom: 1px solid #000; 
  border-right: 1px solid #000;
}

</style>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../assets/css/pagebreak.css"
  ]
};
Vue.use(VueHtmlToPaper, options);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      noti: [],
      FilteredNoti: [],
      SearchQuery : "",

       perPage: 10,
      pagination: {},
      currentPage: 1,

       selectedName: "ALL TEACHER",
      nameOptions: [],

       selectedView: "ALL VIEW",
      viewOptions: [],

      Busy: false,

       fields: [
        { key: "Parent" },
        { key: "Message" },
        { key: "Time" },
        { key: "Viewed" },
      ],
      receipt: {},
    }
  },
   async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetNoti();
    } else {
      this.GoToLogin();
    }
  },

 async mounted() {
      this.GetNoti();
  },
  methods: {
    GetNoti() {
      this.Busy = true;
         this.$API
        .get(this.$GetReceiptStudentPayment + "?Id=" + this.$route.query.Id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.receipt = response.data;
            this.getPic(receipt);
          }
        });
    },
      getPic(receipt) {
      return "https://54.254.198.108/File" + receipt.ProfilePicture;
    },
     PrintPage() {
      this.$htmlToPaper("printsection");
    },
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");

</style>



